export const reservas = {
    layout: {
        listTitle: 'Caixinhas',
        archivedTitle: 'Caixinhas arquivadas',
        detailTitle: 'Caixinha',
        editTitle: 'Editar Caixinha',
        newTitle: 'Nova Caixinha',
    },
    detail: {
        archiveAccessibility: 'Arquivar caixinha',
        yieldAccessibility: 'Registrar rendimento',
        accountLabel: 'Conta',
        guaranteesLabel: 'Garante limite',
        accountFallback: 'Conta',
        accountNameFallback: 'sua conta',
        remainingLabel: 'Falta',
        deadlineLabel: 'Prazo',
        historyTitle: 'Histórico',
        showLess: 'Ver menos',
        showAll: 'Ver tudo',
        emptyHistory: 'Nada guardado ainda.',
        movementWithdraw: 'Resgatado',
        movementYield: 'Rendimento',
        movementDeposit: 'Guardado',
        deleteMovementAccessibility: 'Excluir movimento',
        withdrawButton: 'Resgatar',
        depositButton: 'Guardar',
        archivedNotice: 'Caixinha arquivada: o valor está congelado e não conta no Disponível. Para guardar ou resgatar, reative em Metas e Caixinhas › Arquivadas.',
        accountInactiveNotice: 'A conta {{account}} foi arquivada ou excluída: a caixinha fica parada e volta junto com a conta.',
        moreOptionsAccessibility: 'Mais opções da caixinha',
        yieldAction: 'Registrar rendimento',
        yieldPill: 'Rendimento',
        editAction: 'Editar caixinha',
        archiveAction: 'Arquivar caixinha',
        deleteAction: 'Excluir caixinha',
    },
    statement: {
        deposit: 'Guardado na caixinha',
        withdraw: 'Resgatado da caixinha',
    },
    // Relatório da caixinha (ADR 0164): o ano mês a mês. O rendimento é somado aqui, não nas
    // receitas da conta.
    report: {
        title: 'Relatório da caixinha',
        entryTitle: 'Relatório da caixinha',
        entryHint: 'Quanto rendeu, mês a mês',
        previousYear: 'Ano anterior',
        nextYear: 'Próximo ano',
        yearSummary: 'Em {{year}}',
        opening: 'Começou o ano com',
        deposited: 'Guardado',
        withdrawn: 'Resgatado',
        yielded: 'Rendimento',
        closingCurrent: 'Hoje',
        closingPast: 'No fim de {{year}}',
        yieldedAllTime: 'Desde o começo, a caixinha rendeu {{amount}}.',
        monthByMonth: 'Mês a mês',
        monthDeposited: '{{amount}} guardado',
        monthWithdrawn: '{{amount}} resgatado',
        monthYielded: '{{amount}} de rendimento',
        monthEmpty: 'Sem movimento',
    },
    // Peças comuns dos sheets Guardar · Rendimento · Resgatar (components/reservas/ReservaSheetParts).
    sheet: {
        infoAccessibility: 'O que acontece com o dinheiro',
        backAccessibility: 'Voltar',
        availableOf: 'Disponível de {{account}}',
        balanceOf: 'Saldo de {{account}}',
    },
    guardarSheet: {
        title: 'Guardar na caixinha',
        amountLabel: 'Valor',
        notesLabel: 'Observação (opcional)',
        notesPlaceholder: 'Ex: sobrou do mês',
        submit: 'Guardar',
        reserveAvailable: 'Reservar {{amount}}',
        completeAndReserve: 'Completar e reservar',
        addAndReserve: 'Adicionar à conta e reservar',
        overAvailableHint: 'Só {{available}} livre em {{account}}. "Completar" põe os {{shortfall}} que faltam na conta (ajuste de saldo) e guarda tudo.',
        // Disponível negativo (ADR 0167): pode ser a conta no vermelho, não só caixinha acima do
        // saldo. O dinheiro que entra fica todo guardado e o negativo continua.
        overAvailableSubmergedHint: 'O Disponível de {{account}} está negativo em {{deficit}}. "Adicionar" põe {{amount}} na conta (ajuste de saldo) e guarda tudo; o Disponível continua negativo.',
        negativeAvailableHint: 'O Disponível de {{account}} está negativo em {{deficit}} e continua assim: os {{amount}} entram e ficam todos guardados.',
        info: 'O dinheiro continua em {{account}}, só fica separado. Não é transferência nem despesa: o saldo total da conta não muda.',
    },
    resgatarSheet: {
        title: 'Resgatar da caixinha',
        amountLabel: 'Valor',
        notesLabel: 'Observação (opcional)',
        notesPlaceholder: 'Ex: precisei usar',
        submit: 'Resgatar',
        all: 'Tudo · {{amount}}',
        info: 'O dinheiro não sai da conta: só deixa de ficar separado e volta para o Disponível de {{account}}.',
    },
    rendimentoSheet: {
        title: 'Registrar rendimento',
        modeYield: 'Quanto rendeu',
        modeTotal: 'Saldo atual',
        derivedYield: 'Rendeu {{amount}}',
        derivedNoYield: 'Informe mais que os {{current}} guardados hoje. Para tirar dinheiro, use Resgatar.',
        notesLabel: 'Observação (opcional)',
        notesPlaceholder: 'Ex: rendimento do mês',
        submit: 'Registrar rendimento',
        info: 'Entra como receita em {{account}} (Investimentos · Juros / Rendimentos) e já fica guardado aqui: o saldo da conta sobe e o Disponível não muda. Para desfazer, apague o rendimento no histórico da caixinha.',
    },
    archiveDialog: {
        title: 'Arquivar caixinha',
        messageWithAmount: 'Os {{amount}} voltam pro Disponível da conta. A caixinha sai da lista, mas você pode reativar depois.',
        messageEmpty: 'A caixinha sai da lista. Você pode reativar depois.',
        confirm: 'Arquivar',
    },
    deleteDialog: {
        title: 'Excluir caixinha',
        message: 'O valor reservado volta para o Disponível da conta. Tem certeza?',
        confirm: 'Excluir',
    },
    movementDeleteDialog: {
        title: 'Excluir movimento',
        message: 'O reservado volta a contar como antes deste movimento. Não mexe em nenhuma transação da conta. Tem certeza?',
        messageYield: 'O rendimento de {{amount}} sai da caixinha e a receita dele sai da conta junto. Tem certeza?',
        confirm: 'Excluir',
    },
    archived: {
        frozenAmount: '{{amount}} congelado',
        noAmount: 'Sem valor',
        accountFallback: 'Conta',
        reactivateAccessibility: 'Reativar {{name}}',
        reactivateButton: 'Reativar',
        emptyTitle: 'Nenhuma caixinha arquivada',
        emptySubtitle: 'Caixinhas arquivadas aparecem aqui para você reativar quando quiser.',
    },
    blockedDialog: {
        title: 'Sem saldo livre pra reativar',
        message: 'A conta {{account}} tem {{available}} livres, mas a caixinha guarda {{frozen}}. Como você quer reativar?',
        addAndReactivate: 'Adicionar {{amount}} à conta e reativar',
        reactivateWith: 'Reativar com {{amount}}',
        reactivateEmpty: 'Reativar zerada',
        cancel: 'Cancelar',
    },
};
